import React, { useEffect, useRef, useState } from 'react';
import {
  CardContent,
  Typography,
  TextField,
  InputAdornment,
  Box,
} from '@mui/material';
import { useAppContext } from '../context/AppContext';
import { financialService } from '../utils/api';

function Others() {
  const { state, actions } = useAppContext();
  const [values, setValues] = useState({
    gold:              state.gold              || '',
    otherInvestments:  state.otherInvestments  || '',
    realEstate:        state.realEstate        || '',
  });

  useEffect(() => {
    setValues({
      gold:             state.gold             || '',
      otherInvestments: state.otherInvestments || '',
      realEstate:       state.realEstate       || '',
    });
  }, [state.gold, state.realEstate, state.otherInvestments]);

  const handleChange = (field) => (e) => {
    const raw   = e.target.value.replace(/,/g, '');
    const value = raw === '' ? '' : parseInt(raw, 10) || 0;
    setValues(prev => ({ ...prev, [field]: value }));
    actions.updateFormData(field, value === '' ? 0 : value);
  };

  const formatNumber = (num) => {
    return num === '' ? '' : new Intl.NumberFormat('en-IN').format(num);
  };

  // ── Ref always holding latest investment fields ───────────────────────────
  const latestRef = useRef(null);
  useEffect(() => {
    latestRef.current = {
      phoneNumber:     state.phoneNumber,
      bankBalance:     state.bankBalance,
      fixedDeposit:    state.fixedDeposit,
      retirementFund:  state.retirementFund,
      bonds:           state.bonds,
      debtMF:          state.debtMF,
      equityMF:        state.equityMF,
      hybridMF:        state.hybridMF,
      invits:          state.invits,
      stocks:          state.stocks,
      pms:             state.pms,
      unlisted:        state.unlisted,
      globalEquity:    state.globalEquity,
      globalBonds:     state.globalBonds,
      globalMF:        state.globalMF,
      realEstate:      state.realEstate,
      gold:            state.gold,
      otherInvestments:state.otherInvestments,
    };
  }); // no deps — runs after every render

  // Fire submitInvestment on unmount (user navigates forward or backward)
  useEffect(() => {
    return () => {
      const s = latestRef.current;
      financialService.submitInvestment(s.phoneNumber, {
        bank_balance:       s.bankBalance,
        fixed_deposit:      s.fixedDeposit,
        retirement_fund:    s.retirementFund,
        bonds:              s.bonds,
        debt_mf:            s.debtMF,
        equity_mf:          s.equityMF,
        hybrid_mf:          s.hybridMF,
        invits:             s.invits,
        stocks:             s.stocks,
        pms:                s.pms,
        unlisted:           s.unlisted,
        global_equity:      s.globalEquity,
        global_bonds:       s.globalBonds,
        global_mf:          s.globalMF,
        real_estate:        s.realEstate,
        gold:               s.gold,
        other_investments:  s.otherInvestments,
      }).catch(err => console.error('submitInvestment failed:', err));
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box>
      <CardContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" sx={{ mb: 2, color: 'primary.main' }}>
            Real Estate & Other Investments
          </Typography>
        </Box>

        <Box sx={{ my: 2 }}>
          <Typography variant="body1" gutterBottom>
            Real Estate (Excluding primary residence)
          </Typography>
          <TextField
            placeholder="total value of real estate"
            value={formatNumber(values.realEstate)}
            onChange={handleChange('realEstate')}
            fullWidth
            type="tel"
            inputMode="numeric"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
        </Box>

        <Box sx={{ mt: 2 }}>
          <Typography variant="body1" gutterBottom>
            Gold (Excluding jewellery)
          </Typography>
          <TextField
            placeholder="total value of gold"
            value={formatNumber(values.gold)}
            onChange={handleChange('gold')}
            fullWidth
            type="tel"
            inputMode="numeric"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
        </Box>

        <Box sx={{ mt: 2 }}>
          <Typography variant="body1" gutterBottom>
            All Other Investments
          </Typography>
          <TextField
            placeholder="total value"
            value={formatNumber(values.otherInvestments)}
            onChange={handleChange('otherInvestments')}
            fullWidth
            type="tel"
            inputMode="numeric"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
        </Box>
      </CardContent>
    </Box>
  );
}

export default Others;